import { Component, OnInit } from '@angular/core';
import { RouterService } from '../../core/service/core/router.sevice';
import { AccountService } from 'app/core/service/app/account.service';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import swal from 'sweetalert2';
import { LoadingComponent } from 'app/core/component/core/loading/loading.component';
import { loadingService } from 'app/core/service/loading.service';

@Component({
  selector: 'app-recover-page',
  templateUrl: './recover-page.component.html'
})
export class recoverPageComponent implements OnInit {
    idUser: number = 0;
    private sub: any;
    form: FormGroup;


  constructor(
    private route: RouterService,
    private activateRoute: ActivatedRoute,
    private accountService: AccountService,
    private loadingService: loadingService
    
    ) {   }

  ngOnInit() 
  {
    this.sub = this.activateRoute.params.subscribe(params => {
        this.idUser = params['idUser'];
        if(this.idUser == 0)
        {
            this.route.go("/");
        }
        else{
            this.form = new FormGroup({
                'password': new FormControl('', [Validators.required]),
                'passwordRepeat': new FormControl('', [Validators.required]),
                'code': new FormControl('', [Validators.required]),
                'idUser': new FormControl(this.idUser),
            });
        }
      });

  }

  recover()
  {
    this.loadingService.showLoading();
      this.accountService.recover(this.form.value).then(result => {
          this.loadingService.closeLoading();
          if(result == "ok")
          {
            swal({
                type: 'success',
                title: 'Proceso completo',
                text: 'Contraseña restaurada correctamente'
            }).then(result => {
              this.accountService.reload();
            });
          }
          else
          {
            swal({
                type: 'error',
                title: 'Disculpe las molestias',
                text: result
            }).then(result => {
              this.accountService.reload();
            });
          }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/page/recover-page/recover-page.component.ts